/**
 * Module de gestion de l'indicateur de défilement et du défilement fluide
 * Affiche ou masque l'indicateur et gère le défilement vers les sections
 */
export default class ScrollManager {
    constructor() {
      // Éléments pour l'indicateur de défilement
      this.scrollIndicator = document.getElementById('scroll-indicator');
      this.featureSection = document.querySelector('.feature-section');
      this.heroSection = document.querySelector('.hero-section');
      
      // Vérifier si les éléments nécessaires existent
      if (!this.scrollIndicator || !this.featureSection) {
        console.warn('Éléments nécessaires non trouvés pour le ScrollManager');
        return;
      }
      
      // Initialiser les comportements
      this.setupIntersectionObserver();
      this.setupScrollListener();
      this.setupSmoothScroll();
    }
    
    // Configuration de l'observateur d'intersection pour l'indicateur
    setupIntersectionObserver() {
      const options = {
        threshold: 0.1,
        rootMargin: '-50px 0px'
      };
      
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) {
            this.showIndicator();
          } else {
            this.hideIndicator();
          }
        });
      }, options);
      
      this.observer.observe(this.featureSection);
    }
    
    // Écouteur de défilement pour masquer l'indicateur lors du défilement
    setupScrollListener() {
      window.addEventListener('scroll', () => {
        if (window.scrollY > 50) {
          this.hideIndicator();
        }
      });
    }
    
    // Configuration du défilement fluide
    setupSmoothScroll() {
      // Sélectionner tous les liens avec .scroll-link
      const scrollLinks = document.querySelectorAll('.scroll-link');
      
      scrollLinks.forEach(link => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          
          // Récupérer l'ID cible depuis l'attribut href
          const targetId = link.getAttribute('href');
          const targetElement = document.querySelector(targetId);
          
          if (targetElement) {
            // Faire défiler vers l'élément cible en douceur
            this.scrollToElement(targetElement);
          }
        });
      });
    }
    
    // Méthode pour afficher l'indicateur
    showIndicator() {
      if (window.scrollY < 50) {
        this.scrollIndicator.style.opacity = '1';
        this.scrollIndicator.style.visibility = 'visible';
      }
    }
    
    // Méthode pour masquer l'indicateur
    hideIndicator() {
      this.scrollIndicator.style.opacity = '0';
      setTimeout(() => {
        if (this.scrollIndicator.style.opacity === '0') {
          this.scrollIndicator.style.visibility = 'hidden';
        }
      }, 300);
    }
    
    // Méthode pour faire défiler vers un élément
    scrollToElement(element) {
      // Utiliser scrollIntoView avec comportement fluide
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }